<main class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <!-- Circles background -->
      <div class="shape shape-style-1 shape-primary alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- SVG separator -->
      <div class="separator separator-bottom separator-skew">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-white" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="card card-profile shadow mt--300">
          <div class="px-5" style="padding-bottom:50px;">
            <div class="" style="margin-top:15vh">
              <h5 style="display: inline;">{{news.newsDate |date}}</h5><h5 style="display: inline; float:right">類別:<a href="#">{{news.newsCat |newsCats}}</a></h5>
              <h1 style="font-weight: bold;">{{news.newsTitle}}</h1>
              <div class="justify-content-center">
                <div class="col-lg-3 order-lg-2">
                  <div class="news-pic">
                    <a href="javascript:void(0)">
                      <img src="{{picpath}}/api_backend/imageFile/files/news/{{news.photo}}">
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <span style="margin: 10px;"[innerHTML]=news.newsContent>
          </span>
          </div>
        </div>
      </div>
    </section>
    
  </main>
  